import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

export async function fetchProCountForLocations(locationIds, token) {
  // locationIds: array of shop _id strings
  // Returns: { [locationId]: count }
  const counts = {};
  await Promise.all(locationIds.map(async (id) => {
    try {
      const res = await axios.get(`${API_BASE}/api/shops/${id}/staff`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      counts[id] = Array.isArray(res.data.staff) ? res.data.staff.length : 0;
    } catch {
      counts[id] = 0;
    }
  }));
  return counts;
}
